














import {
    Component,
    Vue,
    Inject,
} from 'vue-property-decorator';
import HttpClient from '@/api/http-client';
import Logger from '@/utils/logger/logger';
import Panel from '@/views/Panel.vue';
import UserInfo from '@/core/userinfo';
import WebSocket from '@/socket';
import { startNetworkProbe } from '@/utils/network/instance';
import { urlWebSocket } from '@/utils/url';
import { renewToken } from '@/router/auth-guard';

// El token de Auth0 dura 24 h y antes solo se pedia al cargar la pagina: con
// el panel abierto mas de un dia, la reconexion del socket y el siguiente
// cambio de vista fallaban. Auth0 devuelve el token de su cache mientras siga
// vigente, asi que el intervalo no genera trafico hasta que hace falta.
const TOKEN_RENEW_MS = 30 * 60 * 1000;

@Component({
    components: {
        Panel,
    },
})
export default class PanelContainer extends Vue {
    @Inject('logger') logger!: Logger;

    @Inject('httpClient') http!: HttpClient;

    socket!: WebSocket;

    userInfo: UserInfo = UserInfo.fromInit();

    tokenTimer?: number;

    created() {
        const token = sessionStorage.getItem('token') || '';

        UserInfo.fromApi(this.http)
            .then((userinfo: UserInfo) => {
                this.userInfo = userinfo;

                this.$root.$emit('customers', this.userInfo.customers);
                this.$root.$emit('currentDomain', this.userInfo.currentDomain);
            });

        this.socket = WebSocket.fromToken(urlWebSocket, token, this.logger);

        // la sonda mide desde aca y no desde la vista de red: para saber
        // quien tuvo la peor conexion del dia hay que medir siempre, no solo
        // cuando alguien abre esa pantalla
        startNetworkProbe(this.socket);

        this.tokenTimer = window.setInterval(() => {
            renewToken().catch((e) => console.error(e));
        }, TOKEN_RENEW_MS);
    }

    beforeDestroy() {
        window.clearInterval(this.tokenTimer);
    }
}
